import type { RankingData } from "lib/fetchers/rankings";
import CommonHero from "components/commonHero/commonHero";

import RankingTeaser from "../common/rankingTeaser";
import PageLayout from "../common/pageLayout";

const RankingsView = ({ rankings }: { rankings: RankingData[] }) => {
  const renderTeaser = (ranking: RankingData) => (
    <RankingTeaser
      key={ranking.id}
      className="col-span-8 md:col-span-4"
      indexPageDescription={ranking.indexPageDescription as string}
      urlSuffix={ranking.slug}
      thumbnailImage={ranking.rankingImage.url}
      {...ranking}
    />
  );

  return (
    <div className={"content-spacing text-black-rock"}>
      <CommonHero
        title={"Rankings"}
        subtitle={
          "Explore our curated rankings of Europe's top startups and investors, highlighting the key players shaping the ecosystem."
        }
        brandColor={"cerise"}
      />{" "}
      <main data-page-type="rankings">
        <PageLayout>{rankings.map(renderTeaser)}</PageLayout>
      </main>
    </div>
  );
};

export default RankingsView;
